import { useAuth } from '@hourly/contexts/AuthContext';
import { Navigate } from 'react-router';

export default function App() {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/referrals" replace />;
}
